import React from 'react'
import { Box, Button, Paper, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export function NotFoundPage(): React.ReactElement {
  const { t } = useTranslation()

  return (
    <Box
      flexGrow={1}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Paper variant="outlined">
        <Box p={2}>
          <Helmet title={t('notFound.title')} />

          <Typography variant="h5" data-testid="not-found-message">
            {t('notFound.message')}
          </Typography>

          <Box mt={1}>
            <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/"
              fullWidth
            >
              {t('notFound.returnToHome')}
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}
